import { styled } from 'storybook/theming';

export const Panel = styled.div({
    flexGrow: 0,
    display: 'flex',
    alignSelf: 'flex-start',
    flexWrap: 'wrap'
});
